export interface LeaderboardEntry {
  rank: number;
  nickname: string;
  totalStars: number;
  levelsCompleted: number;
}

export async function fetchLeaderboard(limit = 50): Promise<LeaderboardEntry[]> {
  const response = await fetch(`/api/leaderboard?limit=${limit}`);
  if (!response.ok) {
    throw new Error(`Failed to load leaderboard (${response.status})`);
  }
  const body = (await response.json()) as { players: LeaderboardEntry[] };
  return body.players;
}
